<template>
    <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item label="法人">
                        <a-input placeholder="请输入公司法人" v-model="queryParam.legalPerson"></a-input>
                    </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item label="事业群">
                        <a-select
                            v-model="queryParam.bg"
                            :options="businessGroupOptions"
                            placeholder="选择事业群"
                        ></a-select>
                    </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item label="事业处">
                        <a-input placeholder="请输入事业处" v-model="queryParam.bu"></a-input>
                    </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item label="工号">
                        <a-input placeholder="请输入员工工号" v-model="queryParam.employeeNo"></a-input>
                    </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item label="姓名">
                        <a-input placeholder="请输入员工姓名" v-model="queryParam.name"></a-input>
                    </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item label="在职状态">
                        <a-select
                            v-model="queryParam.isWork"
                            :options="[{
                                value: 1,
                                label: '在职',
                            }, {
                                value: 0,
                                label: '离职',
                            }, {
                                value: 2,
                                label: '全部',
                            }]"
                            placeholder="请选择在职状态"
                        ></a-select>
                    </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                        <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                        <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                    </span>
                </a-col>
            </a-row>
        </a-form>
        </div>
        <!-- 查询区域-END -->

        <a-table bordered
        size="middle"
        rowKey="id"
        :pagination="pagination"
        :loading="loading"
        :dataSource="dataSource" 
        :columns="columns" 
        @change="handleTableChange">
         <template slot="mobileSlots"
                slot-scope="text">
            <span>{{text.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")}}</span>
          </template>
          <template slot="isWork"
                slot-scope="text">
            <span>{{text ? "在职": "离职"}}</span>
          </template>
        </a-table>
    </a-card>
</template>


<script>
import {getBusinessGroup} from '@/api/selectOptions';
import {queryEmpList} from '@/api/employee';

export default {
    data() {
        return {
            queryParam: {
                legalPerson: '',
                bg: undefined,
                bu: undefined,
                employeeNo: '',
                name: '',
                isWork: null
            },
            queryHistory: {},
            businessGroupOptions: [],
            loading: false,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: total => `共 ${total} 条`
            },
            columns: [
                {
                    align: "center",
                    title: '序号',
                    dataIndex: 'no',
                    key: 'no',
                },
                {
                    align: "center",
                    title: '工号',
                    dataIndex: 'employeeNo',
                    key: 'employeeNo',
                },
                {
                    align: "center",
                    title: '姓名',
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    align: "center",
                    title: '手机号码',
                    dataIndex: 'mobile',
                    key: 'mobile',
                    scopedSlots: { customRender: 'mobileSlots' }
                },
                {
                    align: "center",
                    title: '法人',
                    dataIndex: 'legalPerson',
                    key: 'legalPerson',
                },
                {
                    align: "center",
                    title: '事业群',
                    dataIndex: 'bgName',
                    key: 'bgName',
                },
                {
                    align: "center",
                    title: '事业处',
                    dataIndex: 'buName',
                    key: 'buName',
                },
                {
                    align: "center",
                    title: '在职/离职',
                    dataIndex: 'isWork',
                    key: 'isWork',
                    scopedSlots: { customRender: 'isWork' }
                },
                {
                    align: "center",
                    title: '资料更新时间',
                    dataIndex: 'updateTime',
                    key: 'updateTime',
                }
            ],
            dataSource: []
        }
    },
    mounted() {
        getBusinessGroup().then(res => {
            this.businessGroupOptions = res
        })
        this.handleTableChange(this.pagination)
    },
    methods: {
        // 生成查询
        searchQuery() {
            this.pagination.current = 1
            this.queryHistory = {...this.queryParam}
            this.handleTableChange(this.pagination)
        },
        // 重置查询
        searchReset() {
            this.queryParam = {
                legalPerson: '',
                bg: null,
                bu: null,
                employeeNo: '',
                name: '',
                isWork: null
            }
            this.businessUnitOptions = []
            if(JSON.stringify(this.queryParam) != JSON.stringify(this.queryHistory)) {
                this.pagination.current = 1
                this.queryHistory = {...this.queryParam}
                handleTableChange(this.pagination)
            }
        },

        handleTableChange(p) {
            this.loading = true
            this.pagination = {...this.pagination, current: p.current, pageSize: p.pageSize}
            const param = {...this.queryHistory, 
                pageSize: p.pageSize, 
                pageNo: p.current,
                isWork: this.queryHistory.isWork == null || this.queryHistory.isWork == 2 ? null : this.queryHistory.isWork,
            }
            queryEmpList(param).then(res => {
                this.dataSource = res.records.map((i, index) => {
                    i.no = index + 1
                    return i
                }) || []
                this.pagination = {...this.pagination, total: res.total}
                this.loading = false
            }).catch(e => {
                this.loading = false
            })
        }
    }
}
</script>